import React from 'react';
import {connect} from 'react-redux';
import {setBillingInformation, toggleCreditCardPopup} from "../../Account/AccountActions";
import CheckBox from "../CheckBox";
import * as misc from "../../../misc";
import {change} from "redux-form";
import {messageBoxEx_Show} from "../../../actions";
import {store} from "../../../main";

class CreditCardPopup extends React.Component {

  state = {};

  closePopup = () => {
    this.props.toggleCreditCardPopup(false)
  };

  saveCC = (e) => {
    misc.ignoreDefault(e);
    const {ccNum, ccName, ccExpMonth, ccExpYear, ccCVV, ccTermsApproved, onCCSave} = this.props.billingInformation;
    let errors = misc.validateCCInfo({
      name: ccName,
      number: ccNum,
      expYear: ccExpYear,
      expMonth: ccExpMonth,
      cvv: ccCVV
    });
    if (!ccTermsApproved) {
      errors.push("Please review and approve the terms of use for this credit card number.");
    }
    if (errors.length > 0) {
      this.props.messageBoxEx_Show(true, 'error', 'Invalid/Missing credit card information', errors.join('<br />'));
      return false;
    }
    store.dispatch(change('newEntity', 'billingAddress.name', ccName));
    if (onCCSave) {
      onCCSave();
      this.props.setBillingInformation({onCCSave: null});
    }
    this.props.setBillingInformation({saveCC: true});
    this.closePopup();
  }

  render() {

    const {saveCC, ccNum, ccType, ccName, ccExpMonth, ccExpYear, ccCVV, ccTermsApproved} = this.props.billingInformation;
    const {paymentProfile} = this.props.formValues;

    return (
      <div className="ui-popup ui-popup--card">
        <div className="ui-popup-header">
          <span className="ui-popup-header__text">
            { saveCC || (paymentProfile && paymentProfile.customerProfileId) ? "Update" : "Add" } Credit Card
          </span>
          <button className="ui-popup-header__close" onClick={this.closePopup}/>
        </div>
        <div className="ui-popup-body ui-popup-body--card">
          <div className="new-account-creditcard-overlay-body">
            <div className="field-row">
              <input className="label-jump" type="text" placeholder="Card Number" value={ccNum}
                     required={true} onChange={(e) => this.props.setBillingInformation({
                ccNum: e.target.value,
                ccType: misc.detectCardType(e.target.value)
              })}/>
              <label>Card Number</label>
              <label className={"field-short field-short--right" + (ccType? ' show' : '')}>{ccType}</label>
            </div>
            <div className="field-row">
              <input className="label-jump" type="text" placeholder="Name on Card" value={ccName} required={true}
                     onChange={(e) => this.props.setBillingInformation({ccName: e.target.value})}/>
              <label>Name on Card</label>
            </div>
            <div className="field-row">
              <div className="field-short">
                <input type="text" placeholder="MM" maxLength="2" size="2" required
                       onChange={(e) => this.props.setBillingInformation({ccExpMonth: e.target.value})}
                       value={ccExpMonth} />/ <input type="text" placeholder="YY" maxLength="2" size="2"
                                                     required={true} value={ccExpYear}
                                                     onChange={(e) => this.props.setBillingInformation({ccExpYear: e.target.value})}/>
                <label>Exp. Date</label>
              </div>
              <div className="field-short field-short--right">
                <label>CVV/CVC</label>
                <input type="text" placeholder="CVV" maxLength="4" size="4" required={true} value={ccCVV}
                       onChange={(e) => this.props.setBillingInformation({ccCVV: e.target.value})}/>
              </div>
            </div>
            <div className="field-row">
              <textarea className="terms" readOnly={true}
                        value="I authorize the above named business to charge the credit card indicated in this authorization form according to the terms outlined above. If the above noted payment dates fall on a weekend or holiday, I understand that the payments may be executed on the next business day. I understand that this authorization will remain in effect until I cancel it in email or writing, and I agree to notify the business in writing of any changes in my account information or termination of this authorization at least 30 days prior to the next billing date. This payment authorization is for the type of bill indicated above. I certify that I am an authorized user of this credit card and that I will not dispute the scheduled payments with my credit card company provided the transactions correspond to the terms indicated in this authorization form. By signing this agreement above signer waives the right to file a chargeback with credit card company once software profile is built. Here’s How Recurring Payments Work: You authorize regularly scheduled charges to your Visa, MasterCard, American Express or Discover card. You will be charged each billing period for the total amount due for that period. A receipt will be emailed to you and the charge will appear on your credit card statement. You agree that no prior-notification will be provided unless your bill is more than the amount stated below, or the payment date changes, in which case you will receive notice from us at least 10 days prior to the payment being collected."/>
              <CheckBox checked={ccTermsApproved}
                        text="I agree to the terms of use for the credit card information entered above"
                        onChecked={(e) => this.props.setBillingInformation({ccTermsApproved: !ccTermsApproved})}/>
            </div>
          </div>
        </div>
        <div className="ui-popup-footer">
          <button className="ui-button ui-button--blue" onClick={this.closePopup}>
            <span className="ui-button-text ui-button--uppercase">Cancel</span>
          </button>
          <button className="ui-button ui-button--green" onClick={this.saveCC}>
            <span className="ui-button-text ui-button--uppercase">Save</span>
          </button>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  const {accountPageInfo, billingInformation} = store.accountState;
  return {
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {
      customerProfileId: null
    },
    accountPageInfo,
    billingInformation
  };
};

const mapDispatchToProps = {
  toggleCreditCardPopup,
  setBillingInformation,
  messageBoxEx_Show
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardPopup);
